import { types } from "../types/types";

const initialState = null;

export const currentReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.curpage:
            return { ...action.payload }

        default:
            return state;
    }
}
